<template>
  <div class="container">
    <div class="row">
      <div
        v-for="(product, i) in products"
        :class="[
          i % 4 === 3 ? 'full-blade col-md-6 col-lg-12' : 'col-md-6 col-lg-4',
        ]"
        class="col-12 products-container"
        :key="'product-' + i"
      >
        <div class="bucket">
          <div class="row">
            <div
              :class="[i % 4 === 3 ? 'col-md-12 col-lg-7' : '']"
              class="col-12"
            >
              <div>
                <img :src="require('@/assets/' + product.background)" />
              </div>
            </div>
            <div
              :class="[i % 4 === 3 ? 'col-md-12 col-lg-5' : '']"
              class="col-12 bucket-lower-section"
            >
              <div class="bucket-content-area">
                <div class="color-selection"></div>
                <h3 v-html="product.product"></h3>
                <ul class="list-inline list-price">
                  <li class="list-inline-item reduced">
                    <template v-if="typeof product.starting !== 'undefined'">
                      Starting at
                    </template>
                    <template
                      v-if="typeof product.cost.reduced !== 'undefined'"
                    >
                      <strike>${{ product.cost.normal }}</strike>
                    </template>
                    <template v-else>${{ product.cost.normal }}</template>
                  </li>
                  <li
                    class="list-inline-item"
                    v-if="typeof product.cost.reduced !== 'undefined'"
                  >
                    ${{ product.cost.reduced }}
                  </li>
                </ul>
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <b-button
                      :variant="btnMain"
                      to="/products/headphones/quiet-comfort-earbud"
                      >Buy</b-button
                    >
                  </li>
                  <li class="list-inline-item">
                    <b-button
                      :variant="btnSecondary"
                      to="/products/headphones/quiet-comfort-earbud"
                      >Learn</b-button
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-bucket",
  props: {
    products: Array,
    btnMain: {
      type: String,
      default: "black",
    },
    btnSecondary: {
      type: String,
      default: "white",
    },
  },
};
</script>

<style scoped lang="scss">
.products-container {
  margin-bottom: 30px;
  @media screen and (min-width: map-get($grid-breakpoints,lg)) {
    &.full-blade .color-selection {
      height: 0;
    }
  }
}
.bucket {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 30px;
  background: #f3f3f3;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: flex-end;
  overflow: hidden;
  @media screen and (min-width: map-get($grid-breakpoints,lg)) {
    padding-top: 100px;
    padding-bottom: 60px;
  }
  img {
    max-width: 100%;
    height: auto;
    @media screen and (max-width: map-get($grid-breakpoints, lg)) {
      padding: 0 15px;
    }
  }
  &-lower-section {
    display: flex;
    align-items: center;
  }
  &-content-area {
    overflow: hidden;
    width: 100%;
    padding: 0 15px;
  }
}
.color-selection {
  height: 140px;
  &:empty {
    height: 70px; /*TODO Add this feature */
  }
}
strike {
  color: #777;
}
</style>
